import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button, Icon } from '@folio/stripes/components';
import { IfPermission } from '@folio/stripes/core';

const ActionMenuClearanceButton = ({
  id,
  onToggle,
  handleClearanceClick,
  suppressList,
  isCleared = false,
}) => {
  const isSuppressed = suppressList?.records?.some(
    record => record.configValue === 'true'
  );

  if (isSuppressed) {
    return null;
  }

  return (
    <IfPermission perm="ui-users.delete,ui-users.opentransactions">
      <Button
        buttonStyle="dropdownItem"
        id={`clickable-clearance-user-${id}`}
        onClick={() => {
          onToggle();
          handleClearanceClick();
        }}
      >
        <Icon icon={isCleared ? "undo" : "times-circle"}>
          <FormattedMessage id={isCleared ? "ui-users.clearance.undo" : "ui-users.clearance.button"} />
        </Icon>
      </Button>
    </IfPermission>
  );
};

ActionMenuClearanceButton.propTypes = {
  id: PropTypes.string.isRequired,
  onToggle: PropTypes.func.isRequired,
  handleClearanceClick: PropTypes.func.isRequired,
  suppressList: PropTypes.object,
  isCleared: PropTypes.bool,
};

export default ActionMenuClearanceButton;